import { useCustomSuspenseQuery } from "@/hooks/use-graphql-client";

import { SalesMastList_ManagementSalesPage_Query } from "./query";

type Props = {
	queryVariables?: {
		hotelID: string;
		startDate: string;
		endDate: string;
	};
};

export const useSalesMastListByStartAndEndDate = ({ queryVariables }: Props) => {
	const { data } = useCustomSuspenseQuery(
		SalesMastList_ManagementSalesPage_Query,
		queryVariables ? { variables: queryVariables } : undefined,
		queryVariables === undefined, // skipToken = true
	);

	return {
		data,
	};
};
